import './App.css';
import './index.css'
import '@n8n/chat/style.css';
import './assets/css/chat.css';
import { createChat } from '@n8n/chat';
import Rutas from './routes/Rutas';
import { useEffect } from 'react';
import { defaultChatOptions } from './config/constants';

function App() {
  useEffect(() => {
    if (process.env.REACT_APP_N8N_DISABLED === 'false') {
      createChat(defaultChatOptions);
    }
  }, []);

  return (
    <div className='flex-1'>
      <Rutas />
    </div>

  );
}

export default App;
